import {request} from '@umijs/max';
import BASEURLCONFIG from "../../config/BASEURLCONFIG";

export async function getCurrent(params = {}) {
  return request('/api/getCurrent', {
    method: 'GET',
    params,
  });
}

export async function getMenuTree(params = {}) {
  return request('/api/perResource/tableTreeForAntPro', {
    method: 'GET',
    params,
  });
}

export async function login(params = {}) {
  return request('/api/login', {
    method: 'POST',
    data: params,
  });
}

export async function getSmsCode(params = {}) {
  return request('/api/getSmsCode', {
    method: 'GET',
    params,
  });
}

export async function sendEmailForContactUs(params = {}) {
  return request('/api/v2/sendEmailForContactUs', {
    method: 'POST',
    data: params,
  });
}

export async function resetPasswordForCurrent(params = {}) {
  return request('/api/v2/resetPasswordForCurrent', {
    method: 'POST',
    data: params,
  });
}

export async function logout(params = {}) {
  return request('/api/logout', {
    method: 'GET',
    params,
  });
}


export async function getMainSystemEnvInfo(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/getEnvInfo', {
    method: 'GET',
    params,
  });
}

export async function findEnvMessage(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/findEnvMessage', {
    method: 'GET',
    params,
  });
}

export async function restartEnterpriseService(params: { enterpriseId: number }) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/enterpriseUsage/restart', {
    method: 'POST',
    params,
  });
}

export async function collectProductContactInfo(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/collectProductContactInfo', {
    method: 'POST',
    data: params,
  });
}


export async function findProductNotice(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/findProductNotice', {
    method: 'GET',
    params,
  });
}

export async function autoLogin(params = {}) {
  return request('/api/v2/autoLogin', {
    method: 'POST',
    data: params,
  });
}

export async function getEnterpriseCode(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/v2/getEnterpriseCode', {
    method: 'GET',
    params,
  });
}


export async function findEnterpriseCodeByMobile(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/v2/findEnterpriseCodeByMobile', {
    method: 'GET',
    params,
  });
}

export async function searchEnterprise(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/v2/searchEnterprise', {
    method: 'GET',
    params,
  });
}

// 获取调用方企业列表
export async function getCallerEnterprises(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/getCallerEnterprises', {
    method: 'GET',
    params,
  });
}

// 更新授权状态
export async function updateAuthorizationStatus(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/updateAuthorizationStatus', {
    method: 'POST',
    params,
  });
}

// 获取企业访问信息
export async function getEnterpriseAccess(params = {}) {
  return request(BASEURLCONFIG.ISWAN_BASE_URL + '/api/front/getEnterpriseAccess', {
    method: 'GET',
    params,
  });
}


export async function findUserRangeForSelect(params = {}) {
  return request('/api/iyb/findUserRangeForSelect', {
    method: 'GET',
    params,
  });
}

// 微信扫码登录 - 获取二维码
export async function getWechatLoginQrCode(params = {}) {
  return request('/api/wechat/getLoginQrCode', {
    method: 'GET',
    params,
  });
}

// 微信扫码登录 - 轮询扫码状态
export async function checkWechatScanStatus(params: { sceneId: string }) {
  return request('/api/wechat/checkScanStatus', {
    method: 'GET',
    params,
  });
}

// 申请加入企业
export async function applyJoinEnterprise(params: { enterpriseCode: string }) {
  return request('/api/enterprise/applyJoin', {
    method: 'POST',
    data: params,
  });
}
